import React from "react";

import "./styles/ControlSpinner.css";

export function ControlSpinner() {
  return (
    <div className="ControlSpinnerContainer">
      <div className="ControlSpinnerLoader"></div>
    </div>
  );
}
